// extracted by mini-css-extract-plugin
export default {"sidebar":"Sidebar_sidebar__TTYAt","nav":"Sidebar_nav__Kav3s","link":"Sidebar_link__mVAGN","active":"Sidebar_active__tuHV6"};